import LeftMenuItem from "./LeftMenuItem"
import { useSelector } from "react-redux"
import {getUser, isEmployeeUser} from "../../store/auth/auth.selectors"
import { userRoles } from "../../constants"

const LeftMenuBlock = ({ name, itemArray, isCollapsed }) => {
  const userData = useSelector(getUser)
  const isEmployee = useSelector(isEmployeeUser)
  const userPermissions = userData?.permissions || []

  const visibleItems = itemArray.filter((item) => {
    if (isEmployee && item.hideForEmployee) return false
    if (!isEmployee && item.showOnlyForEmployee) return false
    if (item.permission && !userPermissions.includes(item.permission)) return false
    return true
  })

  if (visibleItems.length === 0) return null

  return (
    <div className="sidebar-menus">
      <h6
        style={{
          padding: isCollapsed ? 0 : "0 0 0 17px",
          textAlign: isCollapsed ? "center" : "left"
        }}>
        {name}
      </h6>

      <ul>
        {visibleItems.map((item) => (
          <LeftMenuItem key={item.name} menuItem={item} isCollapsed={isCollapsed} />
        ))}
      </ul>
    </div>
  )
}

export default LeftMenuBlock
